import { render, staticRenderFns } from "./FBottomSheet.vue?vue&type=template&id=2ab0cf98&"
import script from "./FBottomSheet.vue?vue&type=script&lang=js&"
export * from "./FBottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./FBottomSheet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/souzaramon/repos/personal/fluid/pwa-fluid/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {VBottomSheet,VBtn,VIcon,VList,VListTile,VListTileAvatar,VListTileTitle,VSubheader})
